import React from 'react';
import { format, parseISO, isValid } from 'date-fns';

interface SimpleDatePickerProps {
  value: string; // Date in YYYY-MM-DD format
  onChange: (date: string) => void;
  className?: string;
}

export default function SimpleDatePicker({ value, onChange, className = '' }: SimpleDatePickerProps) {
  // Format the display date
  const formatDisplayDate = () => {
    if (!value) return 'Select date';
    
    try {
      const date = parseISO(value);
      if (!isValid(date)) return 'Select date';
      
      return format(date, 'MMM d, yyyy');
    } catch {
      return 'Select date';
    }
  };

  return (
    <div className={`relative ${className}`}>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
      <button
        type="button"
        className="w-full px-4 py-3 text-left rounded-lg border border-border-light 
                 hover:border-primary-300 focus:border-primary-500 focus:ring-2 
                 focus:ring-primary-500/20 outline-none transition-all bg-white"
      >
        <span className={value ? 'text-text-primary' : 'text-text-disabled'}>
          {formatDisplayDate()}
        </span>
      </button>
    </div>
  );
}